// BaseInviteAcceptContext.js

import React, { createContext, useContext, useMemo } from 'react';

import useAcceptPendingBaseInvite from 'hooks/useAcceptPendingBaseInvite';

const BaseInviteAcceptContext = createContext(null);

export const BaseInviteAcceptProvider = ({ children }) => {
  const inviteAccept = useAcceptPendingBaseInvite();

  const value = useMemo(() => inviteAccept, [inviteAccept]);

  return (
    <BaseInviteAcceptContext.Provider value={value}>
      {children}
    </BaseInviteAcceptContext.Provider>
  );
};

export const useBaseInviteAccept = () => {
  const context = useContext(BaseInviteAcceptContext);
  if (!context) {
    throw new Error('useBaseInviteAccept must be used within BaseInviteAcceptProvider');
  }
  return context;
};

export default BaseInviteAcceptContext;
